var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.buttonClass,attrs:{"disabled":_vm.disabled,"aria-label":_vm.label}},_vm.$listeners),[_c('span',[_c('icon',{attrs:{"name":_vm.light ? 'secondary_arrow_down_light' : 'secondary_arrow_down',"size":"9px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }